import { createApi } from '@reduxjs/toolkit/query/react';

import { HydraApiResponse } from 'app/types/hydraData';
import { IUserLog } from 'app/types/user.interface';
import { z3xBaseQuery } from 'app/utils/api.utils';

interface IGetUserLogsArgs {
	page: number;
	itemsPerPage: number;
}

interface IGetUserLogsTransformedResponse {
	logs: IUserLog[],
	total: number
}

export const userLogsApi = createApi({
  reducerPath: 'userLogsApi',
  baseQuery: z3xBaseQuery({ type: 'ld+json' }),
  endpoints: (build) => ({
    getUserLogs: build.query<IGetUserLogsTransformedResponse, IGetUserLogsArgs>({
      query: ({ page, itemsPerPage }) => ({
        url: 'user-login-logs',
        params: { page, itemsPerPage, 'order[loginAt]': 'desc' }
      }),
      transformResponse: (response: HydraApiResponse<IUserLog[]>) => {
        return {
          logs: response['hydra:member'],
          total: response['hydra:totalItems']
        };
      }
    })
  })
});

export const { useGetUserLogsQuery } = userLogsApi;